const type = 'SET_CARD_LOADING';

const setCardLoading = (data) => ({
  data,
  type,
});

export { type };
export default setCardLoading;
